import { StoryblokReactComponent } from './componentsMap';
import { RelatedArticlesStoryblok } from '@/types/types-storyblok';
import { PostRelatedArticles } from './post/related';

export const StoryblokRelatedArticles: StoryblokReactComponent<RelatedArticlesStoryblok> = ({ component, story }) => {
  const categoryUuids = component.category.map(c => (typeof c === 'string' ? c : c.uuid));
  if (categoryUuids.length === 0) return null;
  return <PostRelatedArticles story={story} categoryUuids={categoryUuids} title={component.title} subtitle={component.subtitle} />;
};
